import React, { useMemo } from 'react';
import { useTranslate } from '@src/core/hooks';
import { Button } from '@planne-software/uni/Button';
import { ModalHeader } from '@planne-software/uni';
import { useTheme } from '@planne-software/uni/mui/material';
import { IconArrowRight, IconCircleCheckFilled, IconX } from '@tabler/icons-react';
import { ProductUpsellRow } from './ProductUpsellRow';
import { useProductUpsellModal } from './useProductUpsellModal';
import { Actions, Footer, OfferList, Root, SecondaryButton, SelectedCount, Modal } from './styles';

export const ProductUpsellModal = () => {
  const theme = useTheme();
  const { i18n } = useTranslate();
  const { open, offers, selectedProductIds, closeAndCompletePostAdd, toggleProduct, continueWithSelectedProducts } =
    useProductUpsellModal();
  const selectedProductIdsSet = useMemo(() => new Set(selectedProductIds), [selectedProductIds]);

  return (
    <Modal open={open} onClose={closeAndCompletePostAdd}>
      <Root>
        <ModalHeader
          onClose={closeAndCompletePostAdd}
          iconTitle={<IconCircleCheckFilled size={32} color={theme.tokens.colors['icon-color-success-stronger']} />}
          title={i18n('product_upsell_modal_title')}
          description={i18n('product_upsell_modal_description')}
          divider
        />

        <OfferList>
          {offers.map((offer) => {
            const selected = selectedProductIdsSet.has(offer.productId);
            return <ProductUpsellRow key={offer.id} offer={offer} selected={selected} onToggle={toggleProduct} />;
          })}
        </OfferList>

        <Footer>
          <SelectedCount>{i18n('product_upsell_selected_count', { count: selectedProductIds.length })}</SelectedCount>

          <Actions>
            <SecondaryButton type='button' variant='outlined' startSlot={<IconX />} onClick={closeAndCompletePostAdd}>
              {i18n('product_upsell_no_thanks')}
            </SecondaryButton>

            <Button
              type='button'
              variant='contained'
              disabled={selectedProductIds.length === 0}
              endSlot={<IconArrowRight />}
              onClick={continueWithSelectedProducts}
            >
              {i18n('product_upsell_continue')}
            </Button>
          </Actions>
        </Footer>
      </Root>
    </Modal>
  );
};
